import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, CircularProgress, Typography } from '@mui/material';
import { clearSsoAttemptFlag, safeNextPath } from '../utils/ssoAuth';

const API = process.env.REACT_APP_SERVER_URL;

export default function SsoCallbackPage({ onSuccess }) {
  const navigate = useNavigate();
  const [message, setMessage] = useState('Входим…');

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const code = params.get('code');
    const next = safeNextPath(params.get('next'));

    if (!code) {
      navigate('/', { replace: true });
      return;
    }

    fetch(`${API}/api/auth/sso-exchange`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ code }),
    })
      .then((res) => res.json().then((data) => ({ ok: res.ok, data })))
      .then(async ({ ok, data }) => {
        if (ok && data?.token) {
          localStorage.setItem('token', data.token);
          clearSsoAttemptFlag();
          if (onSuccess) await onSuccess();
          navigate(next, { replace: true });
          return;
        }
        setMessage(data?.message || 'Не удалось войти');
        setTimeout(() => navigate('/', { replace: true }), 1200);
      })
      .catch(() => {
        setMessage('Ошибка входа');
        setTimeout(() => navigate('/', { replace: true }), 1200);
      });
  }, [navigate, onSuccess]);

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minHeight: '50vh', gap: 2 }}>
      <CircularProgress />
      <Typography color="text.secondary">{message}</Typography>
    </Box>
  );
}
